import React, { useState, useEffect, useCallback } from "react";
import { FiShield, FiClock, FiRefreshCw, FiLock, FiAlertCircle } from "react-icons/fi";
import { getApiBaseUrl } from "../../utils/apiConfig";
import "./MaintenanceOverlay.css";

const API = getApiBaseUrl();

export default function MaintenanceOverlay() {
  const [maintenance, setMaintenance] = useState({ enabled: false, message: "", duration: "" });
  const [checking, setChecking] = useState(false);

  const checkMaintenance = useCallback(async () => {
    try {
      setChecking(true);
      const res = await fetch(`${API}/system/maintenance`);
      if (res.ok) {
        const json = await res.json();
        if (json.success && json.data) {
          setMaintenance(json.data);
        }
      }
    } catch (err) {
      console.warn("Could not check maintenance status:", err.message);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    checkMaintenance();
    const interval = setInterval(checkMaintenance, 25000); // Poll every 25 seconds
    return () => clearInterval(interval);
  }, [checkMaintenance]);

  // If on admin routes, do not block the admin portal
  const isAdminRoute = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
  if (isAdminRoute || !maintenance.enabled) {
    return null;
  }

  return (
    <div className="maintenance-overlay-backdrop">
      <div className="maintenance-modal-card">
        <div className="maint-icon-badge">
          <FiShield className="maint-shield-icon" />
          <span className="maint-pulse-ring"></span>
        </div>

        <div className="maint-status-pill">
          <span className="pill-dot"></span>
          Scheduled Platform Maintenance
        </div>

        <h1 className="maint-title">We're Upgrading SoloWay</h1>

        <p className="maint-message">
          {maintenance.message || "SoloWay is currently undergoing scheduled platform maintenance and system upgrades to serve you better."}
        </p>

        {maintenance.duration && (
          <div className="maint-duration-box">
            <FiClock className="duration-icon" />
            <span>Estimated Duration: <strong>{maintenance.duration}</strong></span>
          </div>
        )}

        <div className="maint-notice-banner">
          <FiAlertCircle />
          <span>Public bookings and traveler inquiries are temporarily paused. Live operations will resume automatically upon completion.</span>
        </div>

        <div className="maint-actions-row">
          <button
            type="button"
            className="btn-maint-refresh"
            onClick={checkMaintenance}
            disabled={checking}
          >
            <FiRefreshCw className={checking ? "spin-icon" : ""} />
            {checking ? "Checking Status..." : "Check Status"}
          </button>

          <a href="/admin/login" className="btn-maint-admin-link">
            <FiLock /> Admin Portal
          </a>
        </div>

        <div className="maint-footer-note">
          © {new Date().getFullYear()} SoloWay Sri Lanka. All systems monitored.
        </div>
      </div>
    </div>
  );
}
